import camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';
import { ProductItemDto, ProductItemModel, PostDto, PostModel } from '../../data-layer/posts/types';
import { fromBusinessLiteDto } from '../business/toBusinessModel';
import { toPostContentModel } from './toPostContentModel';

export const toProductModel = (product: ProductItemDto): ProductItemModel => ({
    id: product.id,
    url: product.url,
    title: product.title,
    content: toPostContentModel(product.content),
    priceInfo: {
        currency: product.price_info.currency,
        integerPart: product.price_info.integer_part,
        fractionalPart: product.price_info.fractional_part,
    },
    oldPriceInfo: {
        currency: product.old_price_info?.currency ?? '',
        integerPart: product.old_price_info?.integer_part ?? 0,
        fractionalPart: product.old_price_info?.fractional_part ?? 0,
    },
});

export const toPostModel = (postDto: PostDto): PostModel => ({
    id: postDto.id,
    text: postDto.text,
    reactionState: postDto.reaction_state,
    saved: postDto.saved,
    likes: postDto.likes ?? 0,
    views: postDto.views ?? 0,
    clickouts: postDto.clickouts.map(
        (clickout) => mapKeys(clickout, (_, key) => camelCase(key)) as any,
    ),
    tags: postDto.tags,
    status: postDto.status,
    source: postDto.data_source,
    url: `/businesses/${postDto.business.public_id}/posts/${postDto.id}`,
    shareUrl: postDto.post_url,
    business: fromBusinessLiteDto(postDto.business),
    createdAt: postDto.created_at,
    djRequestId: postDto.dj_request_id,
    content: toPostContentModel(postDto.content),
    products: {
        title: postDto.products_info?.title ?? '',
        description: postDto.products_info?.description ?? '',
        buttonTitle: postDto.products_info?.button_title ?? '',
        items: postDto.products_info ? postDto.products_info?.items?.map(toProductModel) : [],
        businessButtonTitle: postDto.products_info?.business_button_title ?? '',
    },
});
